/* eslint-disable react/prop-types */
import i18n from '@wix/wix-vod-shared/src/common/i18n';

import sharedTranslations from 'messages/shared';
import { getFullAccessActionName, FULL_ACCESS_ACTION_NAMES } from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';


/**
 * Is channel sign in to play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
export function isVisible({ channel, video }) {
  return getFullAccessActionName(channel, video) === FULL_ACCESS_ACTION_NAMES.SIGN_IN;
}

/**
 * Channel sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is sharedTranslations.playVideo
 * @return {React.Component}
 */
export default function renderSignInToWatchButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  const translation = props.translation || sharedTranslations.playVideo;
  return i18n.t(translation);
}



// WEBPACK FOOTER //
// ./src/widget/components/overlay-texts/video/sign-in-to-watch-button-text.js